import React from 'react';
import { HeroSlideshow } from '@qwickapps/react-framework';
import type { HeroSlide } from '@qwickapps/react-framework';

const slides: HeroSlide[] = [
  {
    title: '100% Local & Private',
    subtitle: 'Everything stays in your browser. Your documents never leave your device.',
    backgroundGradient: 'linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-secondary) 100%)',
  },
  {
    title: 'No Server Required',
    subtitle: 'No uploads, no cloud storage, no data collection. Your privacy is guaranteed.',
    backgroundGradient: 'linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-secondary) 100%)',
  },
  {
    title: 'Professional Letterheads',
    subtitle: 'Add company branding with customizable headers and footers.',
    backgroundGradient: 'linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-secondary) 100%)',
  },
  {
    title: 'Rich Typography',
    subtitle: 'Choose from professional templates or customize every detail.',
    backgroundGradient: 'linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-secondary) 100%)',
  },
  {
    title: 'Live Preview',
    subtitle: 'See your formatted document as you type.',
    backgroundGradient: 'linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-secondary) 100%)',
  },
  {
    title: 'Markdown Powered',
    subtitle: 'Use the simplicity of markdown with the power of professional formatting.',
    backgroundGradient: 'linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-secondary) 100%)',
  },
];

export const HeroSection: React.FC = () => {
  return (
    <HeroSlideshow
      slides={slides}
      autoPlayInterval={3000}
      showDots={true}
      blockHeight="small"
      textAlign="center"
    />
  );
};
